import { useMemo, useState } from "react";
import SiteLayout from "@/components/feature/SiteLayout";
import PageMeta from "@/components/feature/PageMeta";
import PageHero from "@/components/feature/PageHero";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import ArticleCard from "@/components/feature/ArticleCard";
import { articleCategories, articles } from "@/mocks/articles";

export default function ArticlesPage() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () =>
      active === "全部"
        ? articles
        : articles.filter((item) => item.category === active),
    [active],
  );

  const popular = useMemo(() => articles.slice(0, 3), []);

  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "Blog",
      name: "511 求证笔记",
      description:
        "记录整理 511 爆料 时使用的求证流程、证据核查工具与来源分级标准。",
      inLanguage: "zh-CN",
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://balha.cn/" },
        {
          "@type": "ListItem",
          position: 2,
          name: "求证笔记",
          item: "https://balha.cn/articles",
        },
      ],
    },
  ];

  return (
    <SiteLayout>
      <PageMeta
        title="511求证笔记｜511爆料细节补充的方法与工具"
        description="511求证笔记，分享做511爆料细节补充、时间线整理与来源求实时用到的流程、证据核查方法和来源分级标准，让求证有章可循。"
        keywords="511爆料细节补充,511爆料来源求实,511爆料时间线整理,求证方法,证据核查"
        path="/articles"
        schema={schema}
      />

      <PageHero
        eyebrow="VERIFY NOTES"
        title="求证笔记：方法比结论更值得留下"
        description="这些笔记记录了我们整理 511 爆料 时用到的流程、工具与判断标准。方法公开，读者就能自己复核，而不是只能选择相信。"
        crumbs={
          <Breadcrumbs items={[{ label: "首页", to: "/" }, { label: "求证笔记" }]} />
        }
      />

      <section className="w-full px-4 py-10 md:px-6 md:py-14 lg:px-10">
        <div className="mb-8 flex flex-wrap gap-2">
          {articleCategories.map((category) => (
            <button
              key={category}
              type="button"
              onClick={() => setActive(category)}
              className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
                active === category
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : "border-background-300 bg-background-100 text-foreground-600 hover:border-primary-300 hover:text-foreground-950"
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-10">
          <div className="lg:col-span-2">
            {list.length > 0 ? (
              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                {list.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <p className="rounded-lg border border-dashed border-background-300 bg-background-100 p-8 text-center text-sm text-foreground-500">
                该分类下暂时没有笔记。
              </p>
            )}
          </div>

          <aside className="flex flex-col gap-5">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h2 className="font-heading text-base font-semibold text-foreground-950">
                先读这三篇
              </h2>
              <div className="mt-4 flex flex-col gap-3">
                {popular.map((article) => (
                  <ArticleCard key={article.id} article={article} variant="compact" />
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-accent-300 bg-accent-100 p-5">
              <h2 className="font-heading text-base font-semibold text-accent-900">
                求证三原则
              </h2>
              <ul className="mt-4 flex flex-col gap-3 text-xs leading-relaxed text-accent-900/90">
                <li>先追到最早出处，再讨论内容真假。</li>
                <li>两个来源互不相干，才算互相印证。</li>
                <li>材料不足时如实写存疑，不用推测补全。</li>
              </ul>
            </div>
          </aside>
        </div>
      </section>
    </SiteLayout>
  );
}